export const checkbox0 = "M15,2.55556v10.88884c0,0.8556 -0.7,1.5556 -1.5556,1.5556h-10.88884c-0.85556,0 -1.55556,-0.7 -1.55556,-1.5556v-10.88884c0,-0.85556 0.7,-1.55556 1.55556,-1.55556h10.88884c0.8556,0 1.5556,0.7 1.5556,1.55556z"

export const checkbox1 = "M12,9h-8v-2h8z"

export const checkbox2 = "M6.57143,12l-3.57143,-3.83877l1.00714,-1.08254l2.56429,2.74857l5.42147,-5.82726l1.0071,1.09021z"

export const downChevron = "M13,6.175l-5,5l-5,-5l1.175,-1.175l3.825,3.81667l3.825,-3.81667z"

export const leftChevron = "M7.35833,8l3.81667,3.825l-1.175,1.175l-5,-5l5,-5l1.175,1.175z"

export const radio0 = "M15,8c0,3.864 -3.136,7 -7,7c-3.864,0 -7,-3.136 -7,-7c0,-3.864 3.136,-7 7,-7c3.864,0 7,3.136 7,7z"

export const radio1 = "M11,8c0,1.656 -1.344,3 -3,3c-1.656,0 -3,-1.344 -3,-3c0,-1.656 1.344,-3 3,-3c1.656,0 3,1.344 3,3z"

export const rightChevron = "M11.175,8l-5,5l-1.175,-1.175l3.81667,-3.825l-3.81667,-3.825l1.175,-1.175z"

export const upChevron = "M13,10l-1.175,1.175l-3.825,-3.81667l-3.825,3.81667l-1.175,-1.175l5,-5z"